import React, { useEffect, useState } from 'react';
import i18n from 'i18next';
import isEqual from 'lodash/isEqual';

import { Form } from 'core/forms';
import { useModals } from 'core/notifications';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import styles from '../styles/addSourceMaterialModal.module.scss';

const addSetIsFileUploadingToSchema = ({ schema, setIsFileUploading }) => {
  const newSchema = { ...schema };

  Object.keys(newSchema).forEach((key) => {
    if (newSchema[key] === 'source_content_type' || newSchema[key] === 'catalog_activity') {
      return;
    }

    newSchema[key].setIsFileUploading = setIsFileUploading;
  });

  return newSchema;
};

const isModelEqual = ({ model, modifiedModel }) => {
  const clonedModel = { ...model };
  const clonedModifiedModel = { ...modifiedModel };

  delete clonedModel.source_content_type;
  delete clonedModifiedModel.source_content_type;

  return isEqual(clonedModel, clonedModifiedModel);
};

const AddSourceMaterialModal = ({ model, onSubmit, schema }) => {
  const { removeModal } = useModals();
  const [modifiedModel, setModifiedModel] = useState(model);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [isFileUploading, setIsFileUploading] = useState(false);

  const onCancel = () => {
    removeModal();
  };

  const onUpdate = ({ update, hasError }) => {
    const newModel = {
      ...modifiedModel,
      ...update,
    };

    setModifiedModel(newModel);
    setIsSaveButtonDisabled(hasError || isModelEqual({ modifiedModel: newModel, model }));
  };

  const onClick = async () => {
    await onSubmit(modifiedModel);
    removeModal();
  };

  return (
    <div className={styles.element}>
      <Typo className={styles.title} element="h2" variant="d05">
        {i18n.t('course-properties.add-source-material')}
      </Typo>
      <div className={styles.form}>
        <Form
          model={modifiedModel}
          onUpdate={onUpdate}
          schema={addSetIsFileUploadingToSchema({ schema, setIsFileUploading })}
        />
      </div>
      <div className={styles.actions}>
        <Button
          text={i18n.t('save')}
          color="brand"
          onClick={onClick}
          isDisabled={isSaveButtonDisabled || isFileUploading}
        />
        <Button text={i18n.t('cancel')} variant="text" onClick={onCancel} />
      </div>
    </div>
  );
};

export default AddSourceMaterialModal;
